if (!customElements.get('condition-info-popover')) {
  customElements.define(
    'condition-info-popover',
    class ConditionInfoPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.cartMobileMql = window.matchMedia('(max-width: 749px)');
        this.trigger = this.querySelector('.condition-info-popover__trigger');
        this.content = this.querySelector('.condition-info-popover__content');
        this.isOpen = false;

        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.positionForCartMobile = this.positionForCartMobile.bind(this);

        this.trigger.addEventListener('click', this.onTriggerClick.bind(this));
        this.trigger.addEventListener('mouseenter', this.onMouseEnter.bind(this));
        this.addEventListener('mouseleave', this.onMouseLeave.bind(this));
        document.addEventListener('click', this.onDocumentClick);
        window.addEventListener('resize', this.positionForCartMobile);
        window.addEventListener('load', this.positionForCartMobile);
        if (document.fonts) document.fonts.ready.then(this.positionForCartMobile);
      }

      connectedCallback() {
        // a layout pass may not have run yet (styles/fonts still applying), so measuring
        // on the very next frame instead of synchronously avoids a stale/wrong reading
        requestAnimationFrame(this.positionForCartMobile);
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        window.removeEventListener('resize', this.positionForCartMobile);
        window.removeEventListener('load', this.positionForCartMobile);
      }

      onMouseEnter() {
        if (this.mql.matches) this.open();
      }

      onMouseLeave() {
        if (this.mql.matches) this.close();
      }

      onTriggerClick(event) {
        event.preventDefault();
        if (this.mql.matches) return; // desktop is hover-driven
        this.isOpen ? this.close() : this.open();
      }

      onDocumentClick(event) {
        if (this.isOpen && !this.contains(event.target)) this.close();
      }

      open() {
        this.isOpen = true;
        this.trigger.setAttribute('aria-expanded', 'true');
        this.content.setAttribute('aria-hidden', 'false');
        this.content.classList.add('condition-info-popover__content--visible');
        this.positionForCartMobile();
      }

      // cart badges aren't guaranteed centered/full-width in their row, so CSS-only
      // `left: 50%` centering (relative to the tiny trigger) can overflow the
      // viewport - measure the real trigger position and clamp against the actual
      // viewport width instead. Runs eagerly (connect/resize), not just on open,
      // so the (invisible but still laid out) box never overflows while closed.
      positionForCartMobile() {
        if (!this.cartMobileMql.matches || !this.closest('.cart-item__details')) return;

        const margin = 16;
        const contentWidth = this.content.offsetWidth;
        const anchorRect = this.getBoundingClientRect();
        const triggerRect = this.trigger.getBoundingClientRect();

        let left = triggerRect.left + triggerRect.width / 2 - contentWidth / 2;
        left = Math.min(Math.max(left, margin), window.innerWidth - contentWidth - margin);

        this.content.style.left = `${left - anchorRect.left}px`;
        this.content.style.transform = 'none';
      }

      close() {
        this.isOpen = false;
        this.trigger.setAttribute('aria-expanded', 'false');
        this.content.setAttribute('aria-hidden', 'true');
        this.content.classList.remove('condition-info-popover__content--visible');
      }
    },
  );
}
